import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "q-gutter-sm q-mb-sm" }
const _hoisted_3 = { class: "row no-wrap justify-between q-col-gutter-x-md" }
const _hoisted_4 = { class: "row items-center" }
const _hoisted_5 = { class: "text-h4 text-weight-medium" }
const _hoisted_6 = { class: "text-center column" }
const _hoisted_7 = { class: "text-body2 q-mt-xs row justify-between" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-grey-7" }
const _hoisted_10 = { class: "text-grey-7" }
const _hoisted_11 = { class: "text-body1 q-gutter-md q-mt-md" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "q-my-sm"
}
const _hoisted_14 = { class: "q-gutter-sm q-my-sm" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "text-h6" }, "Delete this message?", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "column q-gutter-sm q-my-sm" }, null, -1)

import { computed, onBeforeUpdate, ref } from 'vue'
import { sanitizeMessage, useMessages } from '../store/useMessages'
import { useFormatDate } from '../composables/formatDate'
import { useRoute } from 'vue-router'
import BannerOffline from '../components/BannerOffline.vue'
import FormMessage from '../components/FormMessage.vue'
import AttachmentLink from '../components/message/AttachmentLink.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageMessage',
  setup(__props) {

const { message: getMessage, deleteMessage, send } = useMessages()
const route = useRoute()
const messageID = ref(Number(route.params.id))
const message = ref(getMessage(messageID.value))
onBeforeUpdate(() => {
  messageID.value = Number(route.params.id)
  message.value = getMessage(messageID.value)
})

const renderBody = computed(() => {
  return sanitizeMessage(message.value.message.body)
})
const renderDate = computed(() => {
  const messageDate = useFormatDate(message.value.message.date)
  const dateTime = `${messageDate.weekday()}, ${messageDate.month()} ${messageDate.day()}, ${messageDate.time()}`
  if (
    new Date().getDate() == message.value.message.date.getDate() &&
    new Date().getMonth() == message.value.message.date.getMonth() &&
    new Date().getFullYear() == message.value.message.date.getFullYear()
  ) {
    return `${dateTime}` //format Monday, July 18, 12:02 PM
  } else {
    const today = new Date()
    const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
    const days = Math.round(
      Math.abs((today.getTime() - message.value.message.date.getTime()) / oneDay)
    )
    if (days < 2) {
      return `${dateTime} (${days} day ago)` //format Monday, July 18, 12:02 PM (4 days ago)
    } else {
      return `${dateTime} (${days} days ago)` //format Monday, July 18, 12:02 PM (4 days ago)
    }
  }
})

const modalConfirmation = ref(false)
const modalReplyMessage = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BannerOffline, { "data-test": "pageInventory" }, {
      default: _withCtx(() => [
        _createTextVNode(" You are offline, messages will be sent/recieved when the device is connected. ")
      ]),
      _: 1
    }),
    (message.value.message)
      ? (_openBlock(), _createBlock(_component_q_page, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_btn, {
                  color: "white",
                  "text-color": "grey-7",
                  class: "no-padding",
                  flat: "",
                  rounded: "",
                  "no-caps": "",
                  icon: "arrow_back",
                  label: "Back",
                  to: "/messaging"
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(message.value.message.subject), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (message.value.message.priority)
                    ? (_openBlock(), _createBlock(_component_q_badge, {
                        key: 0,
                        color: "warning",
                        class: "text-black q-py-xs text-body2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "priority_high",
                            class: "q-mr-xs"
                          }),
                          _createTextVNode(" High Priority ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  (message.value.sent)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "To: "))
                    : _createCommentVNode("", true),
                  _createElementVNode("strong", null, _toDisplayString(message.value.sent ? message.value.message.to.name : message.value.message.from.name), 1),
                  _createElementVNode("span", _hoisted_9, " <" + _toDisplayString(message.value.sent ? message.value.message.to.username : message.value.message.from.username) + ">", 1)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(renderDate.value), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", { innerHTML: renderBody.value }, null, 8, _hoisted_12)
              ]),
              (message.value.message.attachment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.value.message.attachments, (attachment, index) => {
                      return (_openBlock(), _createBlock(AttachmentLink, {
                        key: index,
                        attachment: attachment
                      }, null, 8, ["attachment"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_q_btn, {
                  color: "primary",
                  rounded: "",
                  "no-caps": "",
                  label: "Reply",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (modalReplyMessage.value = true))
                }),
                _createVNode(_component_q_btn, {
                  color: "negative",
                  flat: "",
                  rounded: "",
                  "no-caps": "",
                  label: "Delete",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (modalConfirmation.value = true))
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: modalReplyMessage.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modalReplyMessage).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"width":"480px","max-width":"80vw"},
          class: "q-pa-md"
        }, {
          default: _withCtx(() => [
            _createVNode(FormMessage, {
              reply: "",
              message: message.value,
              sent: message.value.sent,
              onSend: _cache[2] || (_cache[2] = ($event: any) => (_unref(send)($event), _ctx.$router.push('/messaging')))
            }, null, 8, ["message", "sent"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: modalConfirmation.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalConfirmation).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"width":"320px","max-width":"80vw"},
          class: "q-pa-md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "text-primary"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  flat: "",
                  label: "Cancel"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  rounded: "",
                  color: "negative",
                  label: "Delete",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (
            _unref(deleteMessage)(message.value.message.id),
              (modalConfirmation.value = false),
              _ctx.$router.push('/messaging')
          ))
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})